module.exports = __webpack_public_path__ + "img/icon_arrow_03.7c7ee355.png";